export const BLOCKED_EVENT_DATA_FIELD_KEYS = {
  INSTALL_BLOCKED: 'install_blocked',
  CLICK_BLOCKED: 'click_blocked',
  OPEN_BLOCKED: 'open_blocked',
  REINSTALL_BLOCKED: 'reinstall_blocked',
  IMPRESSION_BLOCKED: 'impression_blocked',

  PURCHASE_BLOCKED: 'purchase_blocked',
  ADD_TO_CART_BLOCKED: 'add_to_cart_blocked',
  ADD_TO_WISHLIST_BLOCKED: 'add_to_wishlist_blocked',
  VIEW_CART_BLOCKED: 'view_cart_blocked',
  INITIATE_PURCHASE_BLOCKED: 'initiate_purchase_blocked',
  ADD_PAYMENT_INFO_BLOCKED: 'add_payment_info_blocked',
  SPEND_CREDITS_BLOCKED: 'spend_credits_blocked',
  RESERVE_BLOCKED: 'reserve_blocked',
  CLICK_AD_BLOCKED: 'click_ad_blocked',
  VIEW_AD_BLOCKED: 'view_ad_blocked',

  SEARCH_BLOCKED: 'search_blocked',
  VIEW_ITEM_BLOCKED: 'view_item_blocked',
  VIEW_ITEMS_BLOCKED: 'view_items_blocked',
  RATE_BLOCKED: 'rate_blocked',
  SHARE_BLOCKED: 'share_blocked',
  INITIATE_STREAM_BLOCKED: 'initiate_stream_blocked',
  COMPLETE_STREAM_BLOCKED: 'complete_stream_blocked',

  COMPLETE_REGISTRATION_BLOCKED: 'complete_registration_blocked',
  COMPLETE_TUTORIAL_BLOCKED: 'complete_tutorial_blocked',
  ACHIEVE_LEVEL_BLOCKED: 'achieve_level_blocked',
  UNLOCK_ACHIEVEMENT_BLOCKED: 'unlock_achievement_blocked',
  INVITE_BLOCKED: 'invite_blocked',
  LOGIN_BLOCKED: 'login_blocked',
  SUBSCRIBE_BLOCKED: 'subscribe_blocked',
  START_TRIAL_BLOCKED: 'start_trial_blocked',
  OPT_IN_BLOCKED: 'opt_in_blocked',
  OPT_OUT_BLOCKED: 'opt_out_blocked',
} as const;
